export let life = {
  async mounted() {
    // 需要将输入的目标值转换为列表中的对象，提供回显
    this.methods('initModelValue');
  },
  async updated(){
    console.log('组件更新：', this.value);
    if(!this.value){
      this._value = undefined
    }
  }
};
export let event = {};
export let watch = {
};
